// removed by extract-text-webpack-plugin
module.exports = {"block":"_9GKB17OdH13v8kr0aXKF3","zebra":"_3UZAqE1Or7dQTo04CtLIib","yellow":"_1epxL9XBZ31U4Ljr-ytLYs","darkgray":"NYJYS-u_r8VgCQqcAlDtg","lightgray":"RaOXHglYC3xzxWDEPx3Mw","white":"_2e7EPn7Ukl9P8KlgrAt4Ec","wrapper":"_2KnMuDTpWgP2AFybuaYxxZ","content":"_10Mxpfs6tfCevfCW-gKUWj","heading":"cB-L7UjsRlvPv9bVdX0oO","linkedArticle":"_2JiGOt_oB6utvLEihUq7Gn","item":"_1A26fgdlaVyGpVDV4wBPMu","wysiwyg":"_3q7IS-ZM8mtT3-nCU7gbfo","title":"_30EkPjbyvJxZMBa5DA-_xz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureListBlock/FeatureListBlock.module.scss
// module id = 761
// module chunks = 0